import React, {useState, createContext} from 'react'

const RecurringDetailsContext = createContext()

function RecurringDetailsContextProvider(props) {
  const [recurrence_attributes, setRecurrenceAttributes] = useState({
    status: false,
    frequency: 1,
    duration: 'month',
    willStop: 'Never',
    occurrences: 1,
    audit_appear_days: 7,
  })

  const [showRecurrence, setRecurrence] = useState(false)

  const resetRecurringDetails = () => {
    setRecurrenceAttributes({
      ...recurrence_attributes,
      status: false,
      frequency: 1,
      duration: 'month',
      willStop: 'Never',
      occurrences: 1,
      audit_appear_days: 7,
    })
    setRecurrence(false)
  }

  const acomplishedRecurrenceData = () => {
    if (recurrence_attributes.willStop === 'After') {
      return recurrence_attributes
    } else {
      return {
        id: recurrence_attributes.id,
        status: recurrence_attributes.status,
        frequency: recurrence_attributes.frequency,
        duration: recurrence_attributes.duration,
        occurrences: 999,
        audit_appear_days: recurrence_attributes.audit_appear_days,
      }
    }
  }

  const value = {
    recurrence_attributes,
    showRecurrence,
    setRecurrenceAttributes,
    setRecurrence,
    resetRecurringDetails,
    acomplishedRecurrenceData,
  }

  return (
    <RecurringDetailsContext.Provider value={value}>
      {props.children}
    </RecurringDetailsContext.Provider>
  )
}

const RecurringDetailsContextConsumer = RecurringDetailsContext.Consumer

export {RecurringDetailsContext, RecurringDetailsContextProvider, RecurringDetailsContextConsumer}
